import script from "./ContainerRadioQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerRadioQuestion.vue?vue&type=script&setup=true&lang=js"

import "./ContainerRadioQuestion.vue?vue&type=style&index=0&id=61f834a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f834a6"]])

export default __exports__